<template>
    <Page withNavbar>
        <main>
            <SectionTitle
                withDivider
                :title="config.TUTORIAL_TITLE"
                :description="config.TUTORIAL_DESCRIPTION"
            />
            <section class="steps">
                <div v-for="(step, n) in steps" :key="n" class="step">
                    <div class="picture">
                        <component :is="step.art" :color="config.COLOR_PRIMARY"/>
                    </div>
                    <div class="text">
                        <small>{{ step.description }}</small>
                    </div>
                    <Dots :color="config.COLOR_PRIMARY" :value="n + 1" :size="steps.length"/>
                    <Button v-if="n === steps.length - 1" :color="config.COLOR_SECONDARY" @click="onClick">
                        {{ config.TUTORIAL_CTA }}
                    </Button>
                </div>
            </section>
        </main>
    </page>
</template>
<script>
import { SolutionConsumer, TutorialConsumer } from '../../mixins';
import { Page, Dots } from '../../components/mobile';
import { SectionTitle } from '../../components/shared';

export default {
    name: 'Tutorial',
    components: { Page, Dots, SectionTitle },
    mixins: [SolutionConsumer, TutorialConsumer],
    props: {
        steps: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        onClick () {
            this.completeTutorial();
            this.$emit('complete');
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

main {
    @include container(40px 20px);
    align-content: center;
    flex-grow: 1;

    > section {
        text-align: center;

        &.steps {
            display: grid;
            grid-auto-columns: 100%;
            grid-auto-flow: column;
            overflow: auto;
            scroll-snap-type: x mandatory;

            > .step {
                display: grid;
                gap: 20px;
                justify-items: center;
                align-content: start;
                scroll-snap-align: start;
                scroll-snap-stop: always;

                > .picture {
                    > svg {
                        width: 200px;
                    }
                }

            }
        }
    }
}
</style>
